import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Icon } from "antd";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import {
  checkIfAlertOpened,
  selectGrave,
  showPath,
} from "./../../redux/actions";
import withTracker from "./../../withTracker";
import Directions from "./../../../services/directions";

class Grave extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grave: undefined,
      showPath: undefined,
      showBtn: false,
      follow: undefined,
      img: undefined,
      showGallery: false,
      photoIndex: 0,
      src: undefined,
      title: undefined,
      showAlert: false,
      galleryImgs: [],
    };
  }

  componentDidMount() {
    if (this.props.data.data.graves && this.props.data.data.graves.length) {
      const id = this.props.match.params.id;
      this.setState({
        grave: this.props.data.data.graves[id],
        loading: false,
        showBtn: false,
        follow: false,
      });
      if (
        !this.props.data.selectedGrave ||
        this.props.data.selectedGrave !== this.props.data.data.graves[id].ID
      ) {
        this.props.dispatch(selectGrave(this.props.data.data.graves[id].ID));
      }
    }
  }

  componentWillUnmount() {
    this.setState({ follow: false });
    this.props.dispatch(showPath(undefined, undefined));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.grave !== prevState.grave && this.refs.scroller) {
      this.refs.scroller.scrollTop = 0;
    }
    if (prevProps.match.params.id !== this.props.match.params.id) {
      const id = this.props.match.params.id;
      this.setState({
        grave: this.props.data.data.graves[id],
        showGallery: false,
      });
    }
    if (
      localStorage.getItem(this.props.match.params.cemetery) &&
      localStorage
        .getItem(this.props.match.params.cemetery)
        .includes(this.state.grave.ID) &&
      !this.state.showBtn
    ) {
      this.setState({ showBtn: true });
    }
    if (
      this.state.grave &&
      this.state.grave.Description &&
      this.state.grave !== prevState.grave
    ) {
      this.onGetImagesFromString();
    }
    if (this.state.grave && this.state.grave !== prevState.grave) {
      this.props.dispatch(showPath(undefined, undefined));
    }
  }

  onGetImagesFromString() {
    let allImgs = [];
    let html = this.state.grave.Description;
    html = html.split('src="/').join(`src="${window.location.origin}/`);
    let imgs = html.split('<img src="');
    let imgsx = imgs.map((e) => e.slice(0, e.indexOf('" alt')));
    let titles = imgs.map((e) =>
      e.slice(e.indexOf('alt="') + 5, e.indexOf('" width'))
    );
    for (let imgx in imgsx) {
      imgx > 0
        ? allImgs.push({
            img: imgsx[imgx],
            title: titles[imgx],
            index: imgx - 1,
          })
        : "";
    }

    this.setState({
      galleryImgs: allImgs,
    });
    return;
  }

  createMarkup() {
    let html = this.state.grave.Description;
    html = html.split('src="/').join(`src="${window.location.origin}/`);
    return { __html: html };
  }

  parseToHtml() {
    return (
      <div
        onClick={this.onDivClick.bind(this)}
        dangerouslySetInnerHTML={this.createMarkup()}
      />
    );
  }

  onDivClick(e) {
    if (e.target.tagName === "IMG") {
      let img_src = e.target.src;
      const index = this.state.galleryImgs.find(
        (el) => el.img === img_src
      ).index;
      this.setState({
        photoIndex: index,
        showGallery: true,
      });
    }
  }

  onUpdateMyPath() {
    let myPath = localStorage.getItem(this.props.match.params.cemetery)
      ? localStorage.getItem(this.props.match.params.cemetery).split(",")
      : [];
    let id = this.state.grave.ID;
    let graves = [];

    if (!myPath.includes(id)) {
      myPath.push(id);
      this.setState({ showBtn: true, myPath });
    }
    if (
      localStorage.getItem(this.props.match.params.cemetery) &&
      localStorage.getItem(this.props.match.params.cemetery).length >= 1 &&
      !localStorage.getItem(this.props.match.params.cemetery).includes(id)
    ) {
      graves.push(localStorage.getItem(this.props.match.params.cemetery), id);
      localStorage.setItem(this.props.match.params.cemetery, graves);
    } else {
      localStorage.setItem(this.props.match.params.cemetery, id);
    }
  }

  onRemovePath() {
    //remove grave from my path
    if (localStorage.getItem(this.props.match.params.cemetery) != null) {
      let graves = localStorage
        .getItem(this.props.match.params.cemetery)
        .split(",");
      let sorted = graves.reduce((x, y) => (x.includes(y) ? x : [...x, y]), []);
      var filtered = sorted.filter((e) => parseInt(e) !== this.state.grave.ID);
      localStorage.setItem(this.props.match.params.cemetery, filtered);
      this.setState({ showBtn: false });
    }
  }

  onShowPathToGrave() {
    this.setState({ showAlert: true });
    this.setState({ follow: true });
    let start = this.props.data.entry;

    if (
      this.props.data.currentPosInBounds &&
      this.props.data.currentPosClosest &&
      this.props.data.currentPosClosest.lat &&
      this.props.data.currentPosClosest.lng
    ) {
      start = [
        this.props.data.currentPosClosest.lat,
        this.props.data.currentPosClosest.lng,
      ];
    }

    let path = Directions.findPath(this.state.grave.geometry.closestLL, [
      start[1],
      start[0],
    ]);

    if (path && path.path) {
      const currPath = [
        [
          Number(this.state.grave.geometry.coordinates[0]),
          Number(this.state.grave.geometry.coordinates[1]),
        ],
        ...path.path,
      ];

      if (
        !this.props.data.currPath ||
        (this.props.data.currPath &&
          this.props.data.currPath.join() !== path.path.join())
      ) {
        this.props.dispatch(showPath(currPath, undefined));
      }
    }
  }

  onShowGalery() {
    this.setState({ showGallery: true });
  }

  render() {
    return this.state.grave ? (
      <div className='grave-container-x'>
        {this.state.showGallery &&
          this.state.galleryImgs[this.state.photoIndex] && (
            <Lightbox
              mainSrc={this.state.galleryImgs[this.state.photoIndex].img}
              nextSrc={
                this.state.galleryImgs[
                  (this.state.photoIndex + 1) % this.state.galleryImgs.length
                ] && this.state.galleryImgs.length > 1
                  ? this.state.galleryImgs[
                      (this.state.photoIndex + 1) %
                        this.state.galleryImgs.length
                    ].img
                  : ""
              }
              prevSrc={
                this.state.galleryImgs[
                  (this.state.photoIndex - 1) % this.state.galleryImgs.length
                ] && this.state.galleryImgs.length > 1
                  ? this.state.galleryImgs[
                      (this.state.photoIndex - 1) %
                        this.state.galleryImgs.length
                    ].img
                  : ""
              }
              onMovePrevRequest={() => {
                this.setState({
                  photoIndex:
                    (this.state.photoIndex +
                      this.state.galleryImgs.length -
                      1) %
                    this.state.galleryImgs.length,
                });
              }}
              onMoveNextRequest={() => {
                this.setState({
                  photoIndex:
                    (this.state.photoIndex + 1) % this.state.galleryImgs.length,
                });
              }}
              onCloseRequest={() => this.setState({ showGallery: false })}
              imageCaption={this.state.galleryImgs[this.state.photoIndex].title}
            />
          )}

        {this.state.showAlert === true &&
        !this.props.data.currentPosInBounds &&
        this.props.data.opened === false ? (
          <div className='alert-position'>
            <div className='alert-text'>
              <p>Aktualnie nie znajdujesz się na cmentarzu.</p>
              <p> Ścieżki będa wyznaczane od głównego wejścia.</p>
              <Button
                onClick={() => this.props.dispatch(checkIfAlertOpened(true))}>
                <Icon style={{ fontSize: 20 }} type='close' />
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}
        <Link className='close' to={`/${this.props.data.name}/list`}>
          <Button>
            <Icon style={{ fontSize: 20 }} type='close' />
          </Button>
        </Link>
        <main className='grave-container'>
          <div className='person-heading'>
            <div
              onClick={() =>
                this.setState({
                  photoIndex: 0,
                  showGallery: true,
                })
              }
              style={{
                backgroundImage: this.state.grave.Images
                  ? `url(${window.location.origin}${this.state.grave.Images["1600px"]})`
                  : "",
              }}
              className='person-img'></div>
            <h2>{this.state.grave.FirstName.toUpperCase()}</h2>
            <h2>{this.state.grave.LastName.toUpperCase()}</h2>
          </div>

          <div className='buttons-container'>
            <Button
              key={this.props.data.name}
              className='left'
              onClick={() => this.onShowPathToGrave()}>
              {window.innerWidth > 600 ? "trasa" : " wyznacz trasę"}
              {this.props.data.currentPosInBounds ? (
                <span> od mojego położenia</span>
              ) : (
                <span> od wejścia</span>
              )}
            </Button>
            <Button
              className='center'
              onClick={() =>
                this.setState({
                  photoIndex: 0,
                  showGallery: true,
                })
              }>
              Galeria
            </Button>
            {(localStorage.getItem(this.props.match.params.cemetery) &&
              !localStorage
                .getItem(this.props.match.params.cemetery)
                .includes(this.state.grave.ID)) ||
            !localStorage.getItem(this.props.match.params.cemetery) ? (
              <Button className='right' onClick={() => this.onUpdateMyPath()}>
                DODAJ DO <span> MOJEJ ŚCIEŻKI</span>
              </Button>
            ) : (
              ""
            )}
            {localStorage.getItem(this.props.match.params.cemetery) &&
            this.state.showBtn &&
            localStorage
              .getItem(this.props.match.params.cemetery)
              .includes(this.state.grave.ID) ? (
              <Button className='right' onClick={() => this.onRemovePath()}>
                USUŃ Z <span> MOJEJ ŚCIEŻKI</span>{" "}
              </Button>
            ) : (
              ""
            )}
          </div>

          <div ref='scroller' className='person-body'>
            {this.state.grave && this.state.grave.Description
              ? this.parseToHtml()
              : "Brak danych."}
          </div>
        </main>
      </div>
    ) : (
      ""
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(Grave)));



// WEBPACK FOOTER //
// ./src/js/containers/grave/index.js